import { api, devAgentAuthHeaders, unwrap } from "./core";

export const getUserRules = async (
  orgId: string,
): Promise<{ id: number; text: string; enabled: boolean }[]> =>
  (
    unwrap<{ id: number; content: string; enabled: boolean }[]>(
      (
        await api.get(`/api/rules`, {
          params: { org_id: orgId },
          headers: devAgentAuthHeaders(orgId),
        })
      ).data,
    ) || []
  ).map((rule) => ({
    id: rule.id,
    text: rule.content,
    enabled: rule.enabled,
  }));

export const addUserRule = async (
  orgId: string,
  text: string,
): Promise<{ id: number; text: string; enabled: boolean }> =>
  ({
    ...(unwrap<{ id: number }>(
      (
        await api.post(
          `/api/rules`,
          {
            org_id: orgId,
            content: text,
            category: "general",
            priority: 0,
          },
          { headers: devAgentAuthHeaders(orgId) },
        )
      ).data,
    ) || { id: 0 }),
    text,
    enabled: true,
  });

export const updateUserRule = async (
  ruleId: number,
  orgId: string,
  data: { text?: string; enabled?: boolean },
): Promise<void> => {
  await api.put(
    `/api/rules/${ruleId}`,
    {
      content: data.text,
      enabled: data.enabled,
    },
    { params: { org_id: orgId }, headers: devAgentAuthHeaders(orgId) },
  );
};

export const deleteUserRule = async (ruleId: number, orgId: string): Promise<void> => {
  await api.delete(`/api/rules/${ruleId}`, {
    params: { org_id: orgId },
    headers: devAgentAuthHeaders(orgId),
  });
};
